export const THEME_MODE = { LIGHT: 'light', DARK: 'dark', SYSTEM: 'system' } as const;

export type ThemeMode = (typeof THEME_MODE)[keyof typeof THEME_MODE];
export type ResolvedTheme = typeof THEME_MODE.LIGHT | typeof THEME_MODE.DARK;

export const THEME_STORAGE_KEY = 'timeGoTheme';
export const THEME_ATTRIBUTE = 'data-theme';
// Present on <html> for one motion step after a theme change: colours cross-fade, layout does not move.
export const THEME_TRANSITION_ATTRIBUTE = 'data-theme-transition';
export const DARK_SCHEME_QUERY = '(prefers-color-scheme: dark)';
// The stylesheets spell this class out in their antd selectors; change both together.
export const ANTD_CSS_VAR_KEY = 'css-var-timego';
